import Skeleton from 'react-loading-skeleton'
import {KTCard} from '../../../_metronic/helpers'
import {Container} from 'react-bootstrap'

const SkeletonLoader = () => (
  <Container>
    <KTCard className='mt-5 p-5'>
      <h3 className='text-center'>
        <Skeleton baseColor='#f4f4f4' width={300} borderRadius={'10px'} highlightColor='#c9c9c9' />
      </h3>
      <div className='card card-custom'>
        <div className='card-header card-body flex-column justify-content-center  align-items-center pb-0 border-0'>
          <div className={`d-flex flex-column my-5 w-100`}>
            <Skeleton
              baseColor='#f4f4f4'
              borderRadius={'10px'}
              highlightColor='#c9c9c9'
              height={150}
            />
          </div>
          <div className={`d-flex flex-column my-5 w-100`}>
            <Skeleton
              baseColor='#f4f4f4'
              borderRadius={'10px'}
              highlightColor='#c9c9c9'
              height={150}
            />
          </div>
          <div className={`d-flex flex-column my-5 w-100`}>
            <Skeleton
              baseColor='#f4f4f4'
              borderRadius={'10px'}
              highlightColor='#c9c9c9'
              height={150}
            />
          </div>
        </div>
      </div>
    </KTCard>
  </Container>
)
export default SkeletonLoader